import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';

import { RdsChip } from '../chips/chips.component';
import { RDS_DATE_OPERATION_OPTIONS, RdsDateFilter, RdsDateOperationOption } from '../core/models/filter/date-filter.model';
import { _rdsVerifyMomentJsExists } from '../core/utils/verify-moment-js-util';

@Component({
  selector: 'rds-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['YYYY-MM-DD'],
        },
        display: {
          dateInput: 'YYYY-MM-DD',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class RdsDateFilterComponent implements OnChanges {
  /** Date Filters */
  @Input() filters: Array<RdsDateFilter>;

  /** Whether to use the large chip style variant */
  @HostBinding('class.large-chips')
  @Input()
  largeChips = false;

  /** Event emitted when the user adds new filter */
  @Output() add = new EventEmitter<RdsDateFilter>();
  /** Event emitted when the user removes a filter */
  @Output() remove = new EventEmitter<RdsDateFilter>();

  /* Operations that are currently enabled */
  enabledOptions: { [operation: string]: boolean } = { '>': true, '>=': true, '=': true, '!=': true, '<': true, '<=': true };

  /* Operation label and type */
  allOptions: ReadonlyArray<RdsDateOperationOption> = RDS_DATE_OPERATION_OPTIONS;

  /* Filter from the current control values */
  newValue = new RdsDateFilter(null, null);

  constructor(private cdr: ChangeDetectorRef) {
    // Ensure moment js was added to the application correctly
    _rdsVerifyMomentJsExists();
  }

  /**
   * Emit added values and clear the inputs
   */
  handleAdd(filter: RdsDateFilter) {
    this.add.emit(filter);
    // Reset controls
    this.newValue = new RdsDateFilter(null, null);
  }

  handleRemove(chip: RdsChip) {
    const found = this.filters.find((f) => f.operation.type + f.value.valueOf() === chip.id);
    this.remove.emit(found);
  }

  /**
   * Any time the filters change, determine which operations are still applicable, if any
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.filters) {
      this.enabledOptions = { '>': true, '>=': true, '=': true, '!=': true, '<': true, '<=': true };
      for (const f of changes.filters.currentValue) {
        switch (f.operation.type) {
          case '>':
          case '>=':
            this.enabledOptions['>'] = false;
            this.enabledOptions['>='] = false;
            break;
          case '<':
          case '<=':
            this.enabledOptions['<'] = false;
            this.enabledOptions['<='] = false;
            break;
        }
      }
      this.cdr.markForCheck();
    }
  }
}
